export const formatRemoteLanguages = (
  languages: string
): Array<{ id: string; value: string }> => {
  const languagesObj = JSON.parse(languages)
  return Object.keys(languagesObj).map((lang) => ({
    id: lang,
    value: languagesObj[lang],
  }))
}
